import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useProjects() {
  const { token } = useAuth();
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    if (!token) return;
    axios.get(`${API}/projects`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setProjects(res.data))
      .catch(() => {});
  }, [token]);

  return projects;
}
